<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <ErroResultados></ErroResultados>
            </div>
            <template v-if="!erro && acompanhamento">
                <!-- Renderiza o componente filho apenas se o acompanhamento existir -->
                <ExibirAcompanhamento :acompanhamento="acompanhamento" :permissoes="permissoes"/>
            </template>
        </div>
    </div>
</template>

<script>
    import AcompanhamentoApi from "../../services/AcompanhamentoApi.js";
    import ErroResultados from "../../components/ErroResultados";
    import ExibirAcompanhamento from "../../components/acompanhamento/ExibirAcompanhamento.vue";
    import metaDados from "../../helpers/metaDados.js";
    import Auth from "../../services/Auth";

    export default {
        name: "AcompanhamentoShow",
        metaInfo() {
            let title = this.acompanhamento && this.acompanhamento.processo_sei ? `Processo SEI ${this.acompanhamento.processo_sei}` : 'Visualizar Movimentação';
            const description = title;

            return {
                title,
                titleTemplate: "%s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    {
                        vmid: "twitter:description",
                        name: "twitter:description",
                        property: "twitter:description",
                        content: description,
                    },
                    {
                        vmid: "twitter:title",
                        name: "twitter:title",
                        property: "twitter:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                acompanhamento: null,
                permissoes: {
                    pode_visualizar: true, 
                    pode_criar: true,
                    pode_editar: true,
                    pode_deletar: true
                },
            };
        },
        components: {
            ErroResultados,
            ExibirAcompanhamento,
        },
        created() {
            this.acompanhamentoApi = new AcompanhamentoApi();
            this.carregarAcompanhamentos();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarAcompanhamentos();
                }
            },
        },
        computed: {
            isAdmin() {
                const auth = new Auth();
                const usuario = auth.usuario;
                if (usuario && usuario.funcionalidades) {                    
                    return usuario.funcionalidades.includes('acompanhamentos_new_edit_delete') && 
                           usuario.funcionalidades.includes('cargos_colegiados_new_edit_delete');
                }
                return false;
            }
        },
        methods: {
            carregarAcompanhamentos: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.acompanhamentoApi.cancelTokens.getAcompanhamento) {
                        this.acompanhamentoApi.cancelTokens.getAcompanhamento.cancel();
                    }

                    const data = await this.acompanhamentoApi.getAcompanhamento(
                        this.$route.params.id
                    );

                    // CORREÇÃO: O jbuilder retorna o objeto na raiz (data), e não dentro de data.acompanhamento
                    this.acompanhamento = data;
                    this.permissoes = data.permissoes || this.permissoes;
                    // Trava para ocultar botões se não for Admin
                    this.permissoes.pode_editar = this.isAdmin;
                    this.permissoes.pode_deletar = this.isAdmin;
                    this.permissoes.pode_criar = this.isAdmin;
                    this.carregando = false;
                } catch (err) {
                    if (this.acompanhamentoApi.isCancel(err)) {
                        return;
                    }
                    this.erro = true; 
                    this.carregando = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
/* Seu CSS intocado */
.carregando-show {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.erro-carregando {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: fit-content;
    height: 0px auto;
    margin: 0px auto;
    position: relative;
    overflow-y: auto;
    overflow-x: auto;
    font-size: 1.5rem;
    font-family: "Montserrat-Medium";

    img {
        width: 2rem;
        height: 2rem;
        margin-right: 1.6rem;
    }

    label {
        font-size: 1.3rem;
        color: rgba(255, 255, 255, 0.556);
        display: inline;
        position: relative;
        top: 0rem;
    }
}
</style>